interface IProps {
  label: string;
  value?: string | null;
  icon?: string;
  iconClassName?: string;
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
  onClick?: () => void;
}

const InfoRow = ({
  label,
  value,
  icon,
  className,
  labelClassName,
  valueClassName,
  onClick,
}: IProps) => (
  <div
    className={`text-sm grid grid-cols-6 items-start ${className}`}
    onClick={onClick}
  >
    <span
      className={`text-gray-700 col-span-3 flex items-center gap-2 ${labelClassName}`}
    >
      {icon && <i className={`${icon} text-lg`} />}
      {label}
    </span>
    <span className={`col-span-3 font-medium ${valueClassName}`}>
      {value ?? 'مشخص نشده'}
    </span>
  </div>
);

export default InfoRow;
